<template>
  <div style="height: 100%" class="bom">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.5">
      <template #main>
        <TableMain name="one table" ref="QTHInventPriceTable1" :fields="fields1" :title="'quote_apply'"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="false" :show_filter="true" :isBusy="isBusy" :table_height_adjust="-6"
          :show_toolbar_button="[0, 0, 0, 0, 0]" :loading_width="60"
          :hb_table_class="'hb_table_qth_invent_price_class1'" :only_text="$t('common.show_all')"
          @only_methods="only_main_methods" @on_query="on_query" @current_changed="current_changed">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-input class="ml-1" placeholder="报价申请编号" clearable size="small" style="width: 180px"
              v-model="QuotationTaskNum"></el-input>
            <el-input placeholder="客户名称" class="ml-1" clearable size="small" style="width: 180px"
              v-model="CustName"></el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="QTHInventPriceTable2" :fields="qth_invent_price_fields" :show_query_container="false"
          :title="'quote_apply_detail'" :show_toolbar="false" :date_picker_label="''" :table_height_adjust="8"
          :check_state="true" :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy2"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @current_changed="current_changed_detail">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="QTHInventPriceTable3" :fields="detail_qth_invent_price_fields" :show_query_container="false"
          :title="'quote_apply_invent_price'" :show_toolbar="false" :date_picker_label="''" :table_height_adjust="2"
          :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @on_cell_button_click="on_cell_button_click">
          <template #operation>
            <QueryButton :type="'primary'" :iconClass="'iconfont icon-upload'" :size="'mini'" @on_query="Detail_Submit"
              :label="$t('common.commit')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <el-drawer :size="'70%'" :visible.sync="isShowDrawer" :direction="'rtl'" :modal="false" :before-close="handleClose"
      @opened="opened">
      <template slot="title">
        <span>{{ DrawerTitle }}</span>
      </template>
      <!-- <CaclInventPriceTree :data1="treeData1" :dataAreaId="dataAreaId" @saveQuoteInventPrice="saveQuoteInventPrice"></CaclInventPriceTree> -->
      <SplitContainer21 style="height:100%" :layout="12">
        <template #top>
          <TableMain name="one table" ref="ConfirmInventPriceTable1" :fields="confirm_invent_price_fields"
            :title="'采购价格确认明细表'" :show_query_container="false" :show_toolbar_container="true"
            :show_pagination_container="true" :show_date_picker="true" :show_toolbar="false" :show_filter="true"
            :show_toolbar_state="true" :date_picker_label="date_picker_label" :query_button_label="query_lable"
            :isBusy="isBusy4" :check_state="false" :hb_table_class="'hb_table_inventsei_class1'"
            :table_height_adjust="8" @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]"
            @current_changed="ConfirmInventPriceCurrentChanged">
            <template #operation>
              <el-button type="primary" @click="createConsultApply"><i class="iconfont icon-save"></i>
                &nbsp;&nbsp;创建询价申请
              </el-button>
              <el-button type="success" class="m-2" @click="saveQuoteInventPrice"><i class="iconfont icon-save"></i>
                &nbsp;&nbsp;{{ $t("common.save") }}
              </el-button>
            </template>
          </TableMain>
        </template>
        <template #bottom>
          <TableMain name="one table" ref="ConfirmInventPriceTable2" :fields="confirm_invent_vend_price_fields"
            :title="'采购协议查看明细表'" :show_query_container="false" :show_toolbar_container="true"
            :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false" :show_filter="true"
            :show_toolbar_state="false" :date_picker_label="date_picker_label" :loading_width="50"
            :query_button_label="query_lable" :table_height_adjust="2" :isBusy="isBusy5"
            :hb_table_class="'hb_table_inventsei_class2'">
          </TableMain>
        </template>
      </SplitContainer21>
    </el-drawer>
  </div>
</template>

<script>
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as CostItemsController from "../../controllers/sd/CostItemsController"
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import SplitContainer21 from "../components/container/SplitContainer21"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"
import CaclInventPriceTree from "./CaclInventPriceTree.vue"
export default {
  components: {
    BaseContainer,
    SplitContainer3,
    SplitContainer21,
    TableMain,
    QueryButton,
    CaclInventPriceTree
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -3), new Date()],
      query_lable: this.$t("common.query"),
      fields1: _.cloneDeep(QuotationTaskController.fields.default),
      qth_invent_price_fields: QuotationTaskHandleController.fields.detail_invent_price,
      detail_qth_invent_price_fields: QuotationTaskHandleController.fields.detail_qth_invent_price_fields,
      confirm_invent_price_fields: QuotationTaskHandleController.fields.confirm_invent_price_fields,
      confirm_invent_vend_price_fields: QuotationTaskHandleController.fields.confirm_invent_vend_price_fields,
      QuotationTaskNum: "",
      CustName: "",
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      activeCode: "bomcost",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      isBusy4: false,
      isBusy5: false,
      isAll: false,
      total_cost: 0,
      cur_product_qty: 1,
      DrawerTitle: "",
      isShowDrawer: false,
      dataAreaId: "",
      treeData1: [],
      InventPriceList: [],
      cur_area_m: null,
      Current_QuoteDetail: null
    }
  },
  created() {
    this.fields1 = _.filter(this.fields1, (t) => {
      return t.key != "fcCheckSQOApproved" && t.key != "SQOApprover" && t.key != "is_send_email" && t.key != "quotationType" && t.key !== "fcCheckSQOHasClosed"
    })
  },
  async mounted() {
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    only_main_methods(only_value) {
      this.isAll = only_value
      this.on_query(this.$refs.QTHInventPriceTable1.SetData)
    },
    async on_query(set_data) {
      set_data([])
      this.$refs.QTHInventPriceTable2.SetData([])
      this.$refs.QTHInventPriceTable3.SetData([])
      this.isBusy = true
      let hasDate = true
      let p = { is_deleted: { "=": 0 } }
      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = { like: "%" + this.QuotationTaskNum + "%" }
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = { like: "%" + this.CustName + "%" }
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }
      let _result = await QuotationTaskController.methods.getData(p, "price")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], (t) => {
          if (t.fcCheckSQOApproved && !t.fcCheckSQOIsAllClosed && !t.fcCheckQuoteDetailIsAllOutsourcing) return t
        })
        _.each(dt, (t) => {
          t._error = !t.fcCheckQuoteConfirmIsOk
        })
        if (!this.isAll)
          dt = _.filter(dt, { fcCheckQuoteConfirmIsOk: false })

        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }

      this.isBusy = false
    },
    async current_changed(old, current) {
      if (current) {
        this.isBusy2 = true
        let p = { is_deleted: { "=": 0 } }
        p.QuotationTaskId = { "=": current.id }
        p.IsHomemade = { "<>": 2 }
        let _result = await QuotationTaskController.methods.getDetailData(p)
        if (!_.isNull(_result) && _result && _result.length > 0) {
          let dt = _.map(_result[0], (t) => {
            t.IsHomemade = t.IsHomemade ? 1 : 0
            t.Manufacturer = t.Manufacturer.split(",")
            return t
          })
          this.$refs.QTHInventPriceTable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
        }
        this.isBusy2 = false
      }
    },
    async current_changed_detail(old, current) {
      let dt = []
      this.Current_QuoteDetail = current
      if (current) {
        let BomData = [], RouteData = []
        if (current.BomID && current.BomID != "") {
          BomData = JSON.parse(current.BomID)
        }
        if (current.RouteID && current.RouteID != "") {
          RouteData = JSON.parse(current.RouteID)
        }

        _.each(BomData, (t) => {
          let m = _.find(dt, { AccountNum: t.AccountNum })
          if (m)
            m["BomID"] = t.BomID
          else
            dt.push(t)
        })
        _.each(RouteData, (t) => {
          let m = _.find(dt, { AccountNum: t.AccountNum })
          if (m)
            m["RouteID"] = t.RouteID
          else
            dt.push(t)
        })
        await this.getInventPrice(current)
      }
      this.$refs.QTHInventPriceTable3.SetData(dt)

    },
    async getInventPrice(current) {
      let rt = await QuotationTaskHandleController.methods.getQuotationTaskInventPriceData({ QuotationTaskDetailId: current.id })
      if (rt) {
        this.InventPriceList = rt[0]
      }
    },
    ///计算
    async caclCost(ct) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.CaclResultData = []
      let task_cur_item = this.$refs.QTHInventPriceTable2.GetCurrentItem()
      let _dataAreadId_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: ct.AccountNum })
      let _dataAreadId = ""
      if (_dataAreadId_m)
        _dataAreadId = _dataAreadId_m.DataArea

      let p = {
        ItemId: task_cur_item.ItemId,
        ProductQty: task_cur_item.BatchQty,
        AccountNum: ct.AccountNum,
        AccountName: ct.AccountName,
        dataAreaId: _dataAreadId,
        BomID: ct.BomID,
        RouteID: ct.RouteID
      }
      await this.on_query_bom(p)
      console.log(this.InventPriceList)
      if (this.CaclResultData && this.CaclResultData.length > 0) {
        this.treeData1 = this.CaclResultData[0].BomCostData
      }
      console.log(this.treeData1)
      if (this.InventPriceList.length > 0) {
        _.each(this.treeData1, (t) => {
          let m = _.find(this.InventPriceList, { ItemId: t.ItemId, AccountNum: t.AccountNum })
          if (m)
            t.cacl_price_wotax = m.Price

          if (t.purch_price != t.cacl_price_wotax) t._error = true
        })
      }
      loading.close()
    },

    async on_query_bom(p) {
      let _rt1 = await InventBomVersionController.methods.getDataBySql({ SearchText: p.ItemId, Active: 1 })
      if (!_.isNull(_rt1) && _rt1 && _rt1.length > 0 && _rt1[0].length > 0) {
        let _rt2 = await CostItemsController.methods.execCalcBomCost(p)
        let cm = {
          id: "",
          InventNum: p.ItemId,
          ProductQty: p.ProductQty,
          AccountNum: p.AccountNum,
          AccountName: p.AccountName,
          CaclRouteData: _rt1[0][0],//工艺路线计算原始数据
          CaclBomCostData: _rt2,//bom成本额计算原始数据
          BomCostData: [],//bom成本额tree数据
          WrkCtrCostData: [],//资源成本tree数据
          CostGroupData: [],//成本组tree数据
          total_cost: 0, //总成本
          dataAreaId: p.dataAreaId,
        }
        this.calcBomCost(cm) //成本额
        this.CaclResultData.push(cm)
      }
    },

    //#region 整理BOM成本额tree
    calcBomCost(p) {
      let dt = p.CaclBomCostData
      if (!_.isNull(dt) && dt && dt.length > 0) {
        this.buildTreeBomCost(dt[0], p.InventNum, p)
      }
      p.BomCostData = _.uniqBy(p.BomCostData, "ItemId")
    },
    buildTreeBomCost(dt, ItemId, rt) {
      let filter_dt = _.filter(dt, { ItemId: ItemId })
      for (var i in filter_dt) {
        let t = filter_dt[i]
        let mt = {
          label: t.DetailItemId + "：" + t.NameAlias,
          ItemId: t.DetailItemId,
          NameAlias: t.NameAlias,
          purch_price: t.purch_price ? _.round(t.purch_price, 6) : 0,
          invent_cost: t.invent_cost ? t.invent_cost : 0,
          real_qty: _.round(t.real_qty, 2),
          product_qty: parseFloat(rt.ProductQty),
          DW_InventUnitId: t.DW_InventUnitId,
          TEC_SpoilageType: t.TEC_SpoilageType,
          AccountNum: rt.AccountNum,
          dataAreaId: rt.dataAreaId,
          CostGroupId: t.CostGroupId,
          DW_ItemGroupId: t.DW_ItemGroupId,
          TEC_SpecType: t.TEC_SpecType,
          TEC_Weight: _.round(parseFloat(t.TEC_Weight) * parseFloat(t.real_qty) / 1000000, 6),
          PmfProductType: t.PmfProductType
          // children: []
        }
        mt.cacl_price_wotax = t.actal_purch_price ? t.actal_purch_price : mt.purch_price
        console.log(mt)
        if (t.AccountRelation == "") {
          mt.cacl_price_wotax = _.round((mt.cacl_price_wotax / 1.13), 6)
        }
        else if (t.InclTax == "是") {
          mt.cacl_price_wotax = _.round((mt.cacl_price_wotax / (1 + t.SEI_TaxValue / 100)), 6)
        }
        mt.actal_purch_price = t.actal_purch_price ? t.actal_purch_price : mt.purch_price
        mt.real_qty = this.getBOMInventTotalQty(mt)

        if (t.has_children == 1)
          this.buildTreeBomCost(dt, mt.ItemId, rt)
        else
          rt.BomCostData.push(mt)
      }
    },
    getBOMInventTotalQty(t) {
      let realQty = t.real_qty
      if (t.TEC_SpoilageType) {
        let spoilage_type_m = _.find(this.$store.state.biz_data.baseData.SpoilageTypeRatio, { SpoilageType: t.TEC_SpoilageType })
        if (spoilage_type_m) {
          let dec = 2
          let unit_m = _.find(this.$store.state.biz_data.baseData.UnitOfMeasure, { Symbol: t.DW_InventUnitId })
          if (unit_m)
            dec = unit_m.DecimalPrecision

          switch (spoilage_type_m.carryType) {
            case "进一": realQty = _.ceil(t.real_qty, dec); break
            case "四舍五入": realQty = _.round(t.real_qty, dec); break
            default: realQty = _.round(t.real_qty, dec); break
          }
        }
        else {
          let dec = 2
          let unit_m = _.find(this.$store.state.biz_data.baseData.UnitOfMeasure, { Symbol: t.DW_InventUnitId })
          if (unit_m)
            dec = unit_m.DecimalPrecision
          realQty = _.round(t.real_qty, dec)
        }
      }
      return realQty
    },
    //#endregion

    //#region 计算明细相关
    async on_cell_button_click(data) {
      let msg = ""
      if (data.item.BomID == "" || !data.item.BomID) {
        msg = "BOM编号不能为空！"
      }
      else if (data.item.RouteID == "" || !data.item.RouteID) {
        msg = "工艺编号不能为空！"
      }
      if (msg != "") {
        this.msgToasts(msg, "info")
        return
      }

      this.DrawerTitle = "物料采购价维护清单【供应商：" + data.item.AccountName + "】"
      this.cur_area_m = data.item
      this.dataAreaId = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: data.item.AccountNum }).DataArea
      await this.caclCost(data.item)
      this.isShowDrawer = true
      this.isBusy4 = true
    },
    opened() {
      this.$refs.ConfirmInventPriceTable1.SetData(this.treeData1)
      this.isBusy4 = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(t => { done() }).catch(t => { })
    },
    async saveQuoteInventPrice() {
      let data = this.$refs.ConfirmInventPriceTable1.my_data
      let price_error_list = _.filter(data, (t) => {
        return t.PmfProductType == '无' && t.cacl_price_wotax == 0
      })
      if (price_error_list.length > 0) {
        let ask = await this.$confirm('生产类型为‘无’的物料计算价格为0，确定继续吗？').then(t => { return true }).catch(t => { return false })
        if (!ask)
          return
      }
      if (data.length == 0) return
      data = _.filter(data, (t) => { return parseFloat(t.cacl_price_wotax) > 0 })
      let cur_detail_m = this.$refs.QTHInventPriceTable2.GetCurrentItem()
      if (!this.cur_area_m || !cur_detail_m) {
        return
      }

      let p = {}
      p.remove = { QuotationTaskDetailId: cur_detail_m.id, AccountNum: this.cur_area_m.AccountNum }
      p.add = []
      _.each(data, (t) => {
        if (t.purch_price != t.cacl_price_wotax) t._error = true
        else delete t._error

        let am = {
          QuotationTaskDetailId: cur_detail_m.id,
          ItemId: t.ItemId,
          AccountNum: this.cur_area_m.AccountNum,
          Price: t.cacl_price_wotax
        }
        p.add.push(am)
      })

      let rt = await QuotationTaskHandleController.methods.saveQuotationTaskInventPriceData(p)
      if (rt) {
        await this.getInventPrice(this.Current_QuoteDetail)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
      this.$forceUpdate()
    },
    ///创建询价申请
    async createConsultApply() {
      let selected_items = this.$refs.ConfirmInventPriceTable1.GetSelectedItems()
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      let ask = await this.$confirm(this.$t("notify.is_continue") + "(注：默认询价申请为启用状态，如果需要进一步处理请到询价申请进行处理！)").then(t => { return true }).catch(t => { return false })
      if (!ask) return

      let qt_cur = this.$refs.QTHInventPriceTable1.GetCurrentItem()
      let qt_detail_cur = this.$refs.QTHInventPriceTable2.GetCurrentItem()
      let p = { add: [], edit: [] }, lineCount = 1
      _.each(selected_items, (t) => {
        let m = _.cloneDeep(t), dp = {}
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        let consult_detail_fields = _.cloneDeep(ConsultQuoteConttroller.fields.application)
        _.each(consult_detail_fields, (ck) => {
          dp[ck.key] = m[ck.key]
        })
        dp.LineNum = lineCount++
        dp.BatchQty = m.real_qty
        dp.QuotationTaskNum = qt_cur.QuotationTaskNum
        dp.CustAccount = qt_cur.CustAccount
        dp.CustName = qt_cur.CustName
        dp.DeliveryAddress = qt_detail_cur.DeliveryAddress
        dp.DeliveryMode = qt_detail_cur.DeliveryMode
        dp.QuotationTaskDetailId = qt_detail_cur.id
        dp.is_valid = true
        delete dp.CostGroupId
        delete dp.DW_ItemGroupId
        delete dp.TEC_SpecType
        p.add.push(dp)
      })

      let rt = await ConsultQuoteConttroller.methods.saveDataDetailApply(p)
      if (rt)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      else
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")

    },
    //查询物料采购价格协议
    async ConfirmInventPriceCurrentChanged(old, current) {
      let dt = []
      this.isBusy5 = true
      if (current) {
        let rt = await QuotationTaskHandleController.methods.getInventPurchDicPriceData({ ItemId: current.ItemId, dataAreaId: current.dataAreaId })
        if (rt) {
          // console.log(rt)
          dt = rt[0]
        }
      }
      _.each(dt, (t) => {
        t.amount_wotax = t.Amount
        if (t.ExchangeRate != 1) {
          t.amount_wotax = _.round((t.amount_wotax * t.ExchangeRate / 100), 6)
        }
        if (t.InclTax && t.InclTax == "是") {
          t.amount_wotax = _.round((t.amount_wotax / (1 + t.SEI_TaxValue / 100)), 6)
        }
        else if (t.InclTax != "否") {
          t.SEI_TaxValue = 13
          t.amount_wotax = _.round((t.amount_wotax / 1.13), 6)
        }
      })
      this.$refs.ConfirmInventPriceTable2.SetData(_.uniqWith(dt, _.isEqual))
      this.isBusy5 = false
    },
    async Detail_Submit(cb) {
      //数据验证
      let lm = {}, p = { add: [], edit: [] }, msg = ""
      if (this.$refs.QTHInventPriceTable3.my_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }
      _.each(this.$refs.QTHInventPriceTable3.my_data, (t) => {
        if (t.BomID == "" || !t.BomID) {
          msg = "BOM编号不能为空！"
        }
        else if (t.RouteID == "" || !t.RouteID) {
          msg = "工艺编号不能为空！"
        }

      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      lm.id = this.$refs.QTHInventPriceTable2.GetCurrentItem().id

      lm["InventPriceConfirmState"] = true
      p.edit.push(lm)
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        let lineCurrent = this.$refs.QTHInventPriceTable2.GetCurrentItem()
        lineCurrent.InventPriceConfirmState = true
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_qth_invent_price_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
}
</style>
